import { render, staticRenderFns } from "./PermissionsDialog.vue?vue&type=template&id=0f073a4d&scoped=true&"
import script from "./PermissionsDialog.vue?vue&type=script&lang=js&"
export * from "./PermissionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsDialog.vue?vue&type=style&index=0&id=0f073a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f073a4d",
  null
  
)

export default component.exports